module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-unknown-4.499eed48.svg";